import React from 'react';
import { Field } from 'redux-form';
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/lib/Async';

const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <div>
    <label>{label}</label>
    <div>
      <input
        {...input}
        type={type}
        placeholder={label}
        className="form-control"
      />
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);

const renderUserField = ({
  input,
  label,
  type,
  meta: { touched, error },
  searchUsers,
}) => (
  <div>
    <label>{label}</label>
    <div>
      <AsyncSelect
        value={input.value}
        cacheOptions
        defaultOptions
        loadOptions={searchUsers}
        getOptionValue={option => option.id}
        getOptionLabel={option => option.name}
        placeholder="Type User Name..."
        menuPlacement="top"
        styles={{
          control: styles => ({
            ...styles,
            borderColor: touched && error ? 'red' : '#cccccc',
          }),
          menu: styles => ({
            ...styles,
            zIndex: 99999,
            color: '#108ee9',
          }),
        }}
        onChange={input.onChange}
      />
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);

const renderDateField = ({ input, label, type, meta: { touched, error } }) => (
  <div>
    <label>{label}</label>
    <div>
      <DatePicker
        className="form-control"
        selected={new Date(input.value)}
        // onChange={() => console.log()}
        onChange={input.onChange}
      />
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);

const renderTasks = ({
  fields,
  searchUsers,
  meta: { error, submitFailed },
}) => (
  <div>
    {submitFailed && error && <span>{error}</span>}
    {fields.map((member, index) => (
      <div key={index}>
        <div className="row">
          <div className="col-md-3">
            <Field
              name={`${member}.title`}
              type="text"
              component={renderField}
              label="Task Title"
            />
          </div>
          <div className="col-md-4">
            <Field
              name={`${member}.notes`}
              type="text"
              component={renderField}
              label="Notes"
            />
          </div>
          <div className="col-md-2">
            <Field
              name={`${member}.dueDate`}
              component={renderDateField}
              label="Due Date"
            />
          </div>
          <div className="col-md-3">
            <Field
              name={`${member}.assignedToItem`}
              component={renderUserField}
              searchUsers={searchUsers}
              label="User"
            />
          </div>
        </div>
      </div>
    ))}
    <br />
    <div className="text-center">
      <button
        type="button"
        className="btn btn-default"
        onClick={() =>
          fields.push({ title: '', notes: '', dueDate: new Date(), assignedTo: '' })
        }
      >
        <i className="fa fa-plus"></i>{` `}
        Add Task
      </button>
    </div>
  </div>
);
export default renderTasks;



// WEBPACK FOOTER //
// ./src/routes/administration/components/ClinicalIncidentTask.js